import React from 'react';

import { flagStyles } from '../settings';

const SvgKN = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2832px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgKN;
